<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" ref="field" :label="label">
        <q-input-frame :error="hasError" :disable="disable" :hide-underline="hideUnderline" :before="before"
            :after="after" :dusk="path" :color="color" class="q-input" :class="{ original: original }">
            <slot><span v-html="displayValue" :class="{ ellipsis: type != 'textarea' }"></span></slot>
        </q-input-frame>
    </v-field>
</template>

<script>
import { path } from 'change-case'
import mixins from './mixins'
import {
    QInputFrame
} from 'quasar-framework'

export default {
    name: 'VDisplayList',
    components: { QInputFrame },
    mixins,

    props: {
        field: String
    },

    computed: {
        displayValue() {
            return this.value.map(i => i[this.field]).join(', ')
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VDisplayList.vue